export const en = {
  common: {
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    loading: 'Loading…',
    copy: 'Copy',
    ok: 'OK',
    close: 'Close',
    or: 'or',
    creating: 'Creating...',
    unknownError: 'Unknown error',
    none: 'None',
    color: 'Color',
    visible: 'Visible',
    locked: 'Locked',
    hide: 'Hide',
    show: 'Show',
    lock: 'Lock',
    unlock: 'Unlock',
    update: 'Update',
  },
  language: {
    label: 'Language',
  },
  auth: {
    welcome:
      'Welcome to tween.studio — design motion, craft scenes, and bring your stories to life.',
    email: 'Email',
    password: 'Password',
    emailPlaceholder: 'you@example.com',
    name: 'Name',
    surname: 'Surname',
    namePlaceholder: 'Ada',
    surnamePlaceholder: 'Lovelace',
    confirmPassword: 'Confirm Password',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    and: 'and',
    signInTitle: 'Sign In',
    signInSubtitle: 'Continue where you left off.',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    loginFailed: 'Login failed',
    googleSignInFailed: 'Google sign-in failed',
    googleSignInLoadFailed: 'Google sign-in could not be loaded',
    continueWithFacebook: 'Continue with Facebook',
    continueWithInstagram: 'Continue with Instagram',
    metaSignInComingSoon:
      '{brand} sign-in uses Meta Login — wiring coming next. Provider is ready to configure in admin.',
    createAccountTitle: 'Create Account',
    createAccountSubtitle: 'Join tween.studio and start animating.',
    createAccount: 'Create Account',
    creatingAccount: 'Creating account...',
    hasAccount: 'Already have an account?',
    signInLink: 'Sign in',
    termsAgreePrefix: 'By creating an account you agree to our',
    termsAgreeSuffix: '.',
    passwordMinLength: 'Password must be at least 6 characters.',
    passwordsDoNotMatch: 'Passwords do not match.',
    registrationFailed: 'Registration failed',
  },
  theme: {
    label: 'Theme',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
  },
  connection: {
    Connected: 'Connected',
    Connecting: 'Connecting',
    Reconnecting: 'Reconnecting',
    Disconnected: 'Disconnected',
    Error: 'Error',
  },
  toolbar: {
    selectMovie: 'Select Movie',
    ai: 'AI',
    notifications: 'Notifications',
    loadingNotifications: 'Loading notifications...',
    noNotifications: 'No notifications yet.',
    zoom: 'Zoom',
    zoomLevel: 'Zoom level',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomPercent: 'Zoom {percent}%',
    shapes: 'Shapes',
    objects3d: '3D objects',
    characters: 'Characters',
    characterPresets: {
      humanoid: 'Humanoid',
      animal: 'Animal',
      turtle: 'Turtle',
      octopus: 'Octopus',
    },
    sceneEffects: 'Scene effects',
    sceneEffectsLabel: 'Scene Effects',
    activeEffects: '{count} active effects',
    clearAllEffects: 'Clear all effects',
    tools: {
      select: 'Select (V)',
      pan: 'Hand (H, hold Space)',
      line: 'Line (L)',
      curve: 'Curve (P)',
      text: 'Text (T)',
      rectangle: 'Rectangle (R)',
      circle: 'Circle (C)',
      triangle: 'Triangle',
      polygon: 'Polygon (G)',
      cube3d: '3D Cube',
      sphere3d: '3D Sphere',
      box3d: '3D Box',
      cylinder3d: '3D Cylinder',
      prism3d: '3D Prism',
      mesh3d: '3D Mesh',
      fog: 'Fog',
      rain: 'Rain',
      snow: 'Snow',
      lightning: 'Lightning',
      particles: 'Particles',
      vignette: 'Vignette',
    },
  },
  movieSelector: {
    newMovie: 'New Movie',
    createNewMovie: 'Create New Movie',
    movieNamePlaceholder: 'movie name...',
    movieDescriptionPlaceholder: 'movie description...',
    recent: 'Recent',
    myProjects: 'My Projects',
    sampleMovies: 'Sample Movies',
    currentMovie: 'Current Movie',
    unloadMovie: 'Unload Movie',
    closeMovie: 'Close movie',
    deleteMovie: 'Delete Movie',
    moreActions: 'More actions',
    selectToPreview: 'Select a movie to preview',
    deleteConfirmTitle: 'Delete movie?',
    deleteConfirmDescription: '"{name}" will be permanently deleted.',
    thisMovie: 'This movie',
    movieAria: 'movie',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: '{count} days ago',
    older: 'Older',
    errors: {
      idUnresolved: 'Movie id could not be resolved.',
      nameEmpty: 'Movie name cannot be empty.',
      saveFailed: 'Failed to save movie. Please try again.',
    },
  },
  userMenu: {
    ariaLabel: 'User menu',
    sectionsAria: 'User menu sections',
    tabs: {
      credits: 'Credits',
      account: 'Account',
      preferences: 'Preferences',
    },
    administration: 'Administration',
    signOut: 'Sign Out',
    loadingCredits: 'Loading credits',
    creditsCount: '{count} credits',
    credits: {
      currentBalance: 'Current Balance',
      unit: 'credits',
      add: 'Add credits',
      hideAdd: 'Hide add credits',
      hideAddOptions: 'Hide add credits options',
      loadingPurchase: 'Loading purchase options...',
      noCardOptions: 'No card payment options configured.',
      planCredits: '{count} credits',
      loadWithTether: 'Load with Tether (USDT)',
      loadingDeposit: 'Loading...',
      noUsdtWallet: 'No USDT wallet address configured.',
      rate: '1 {symbol} = {credits} credits',
      copyAddress: 'Copy address',
      recentTransactions: 'Recent Transactions',
      loadingTransactions: 'Loading transactions...',
      noTransactions: 'No transactions yet.',
    },
    account: {
      creditUsage: 'Credit Usage',
      balance: 'Balance',
      earned: 'Earned',
      spent: 'Spent',
      transactions: 'Transactions',
      changePassword: 'Change password',
      changePasswordTitle: 'Change Password',
      currentPassword: 'Current password',
      currentPasswordHint: 'Leave empty for social-only accounts',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      updatePassword: 'Update password',
      saving: 'Saving…',
      errors: {
        newRequired: 'New password is required.',
        minLength: 'New password must be at least 6 characters.',
        mismatch: 'New password and confirmation do not match.',
        failed: 'Failed to change password.',
      },
      success: 'Password changed successfully.',
    },
  },
  sidebar: {
    collapse: 'Collapse panel',
    expand: 'Expand panel',
  },
  toolpads: {
    library: {
      title: 'Library',
      dropImages: 'Drop images here',
      importFiles: 'Import Files',
      import: '+ Import',
      importAria: 'Import files',
      uploading: 'Uploading…',
      deleteConfirmTitle: 'Delete library item?',
      deleteConfirmDescription: '"{name}" will be permanently deleted.',
      deleteFailedTitle: 'Could not delete',
      deleteFailedFallback: 'Could not delete.',
      inUseTitle: 'Library item in use',
      inUseDescription:
        '"{name}" is used by at least one scene object ({count}). Remove it from the scene first.',
      noLayerTitle: 'No layer selected',
      noLayerDescription: 'Select a layer before adding a scene object.',
      mine: 'Project',
      vectorHint: 'Drag onto the stage or double-click to copy into this project.',
      vectorsEmpty: 'The public library is empty.',
      vectorsLoadFailed: 'Could not load the public library.',
      vectorUseFailed: 'Could not add this library item to the project.',
    },
    scenes: {
      title: 'Scenes',
      empty: 'No scenes yet.',
      add: '+ Add Scene',
      defaultName: 'Scene {count}',
      nameAria: 'Scene name',
      dragReorder: 'Drag to reorder',
      deleteTitle: 'Delete Scene',
      deleteDescription: '"{name}" will be deleted.',
      deleteTooltip: 'Delete Scene',
      cannotDeleteTitle: 'Cannot delete scene',
      cannotDeleteLast: 'A movie must keep at least one scene. The last scene cannot be deleted.',
      createFailed: 'Could not create scene: {error}',
      deleteFailed: 'Could not delete scene: {error}',
    },
    sceneObjects: {
      title: 'Scene Objects',
      empty: 'Add objects to the scene by dragging them from the library.',
      selectAll: 'Select all',
      selectAllAria: 'Select all scene objects',
      selectedCount: '{count} selected',
      expand: 'Expand',
      collapse: 'Collapse',
      objectNameAria: 'Object name',
      selectObject: 'Select {name}',
      selectObjectAndChildren: 'Select {name} and children',
      deselectObjectAndChildren: 'Deselect {name} and children',
      selectAllChildren: 'Select all children',
      all: 'All',
    },
    sceneEffects: {
      title: 'Scene Effects',
      empty: 'Enable scene effects from the toolbar to adjust their parameters here.',
      activeCount: '{count} active',
      clearAll: 'Clear all',
      expand: 'Expand parameters',
      collapse: 'Collapse parameters',
      enable: 'Enable effect',
      disable: 'Disable effect',
      params: {
        intensity: 'Intensity',
        speed: 'Speed',
        particleSize: 'Particle size',
        color: 'Color',
      },
    },
    clipFolders: {
      title: 'Clip Folders',
      empty: 'No clip folders.',
      add: '+ Add Folder',
      defaultName: 'Folder {count}',
      deleteTooltip: 'Delete Folder',
    },
    movieProperties: {
      title: 'Movie Properties',
      stageSize: 'Stage Size',
      width: 'W',
      height: 'H',
      frameRate: 'Frame Rate',
      frameRateAria: 'Frame rate',
      fpsOption: '{count} FPS',
      info: 'Info',
      name: 'Name: ',
      scenes: 'Scenes: ',
      noMovie: 'No movie loaded.',
      publish: 'Publish',
      publishing: 'Publishing…',
      publishHint: 'Creates a read-only snapshot for the public player.',
      linkCopied: 'Player link copied.',
    },
  },
  rightSidebar: {
    style: {
      title: 'Style',
      selectObject: 'Select an object on the stage to adjust colors.',
      shapeOrTextOnly: 'Style settings apply to shape, text, and image objects.',
      text: 'Text',
      textColor: 'Text Color',
      fontSize: 'Font Size',
      fontSizeAria: 'Font size',
      fontSizePxAria: 'Font size px',
      align: 'Align',
      textAlignAria: 'Text align',
      left: 'Left',
      center: 'Center',
      right: 'Right',
      justify: 'Justify',
      colors: 'Colors',
      fill: 'Fill',
      fillModeAria: 'Fill mode',
      fillSolid: 'Color',
      fillGradient: 'Gradient',
      fillColor: 'Fill Color',
      gradientStart: 'Start',
      gradientEnd: 'End',
      gradientAngle: 'Angle',
      gradientAngleAria: 'Gradient angle',
      border: 'Border',
      borderTypeAria: 'Border type',
      borderColor: 'Border Color',
      borderSizeAria: 'Border Size',
      size: 'Size',
      sides: 'Sides',
      sidesAria: 'Border sides',
      sideTop: 'Top',
      sideRight: 'Right',
      sideBottom: 'Bottom',
      sideLeft: 'Left',
      solid: 'Solid',
      dashed: 'Dashed',
      dotted: 'Dotted',
      fillBorderConflict: 'Fill and border cannot both be none.',
      effects: 'Effects',
      shadow: 'Shadow',
      shadowColor: 'Shadow color',
      shadowOffsetX: 'Offset X',
      shadowOffsetY: 'Offset Y',
      shadowBlur: 'Blur',
      shadowSpread: 'Spread',
      glow: 'Glow',
      glowColor: 'Glow color',
      glowBlur: 'Glow blur',
      enabled: 'On',
      disabled: 'Off',
    },
    properties: {
      title: 'Properties',
      object: 'Object',
      tween: 'Tween',
      transform: 'Transform',
      stageTools: 'Stage tools',
      stageResize: 'Resize',
      stageRotate: 'Rotate',
      stageResizeHint: 'Show resize handles on the selected object',
      stageRotateHint: 'Show corner rotate handles and pivot on the selected object',
      pivotHint: 'Drag to set the rotation pivot / joint',
      keepAspectRatio: 'Keep aspect ratio',
      keepAspectRatioHint: 'Also temporarily enabled while resizing with Shift.',
      appearance: 'Appearance',
      rotation: 'Rotation',
      rotationAria: 'Rotation',
      rotationDegreesAria: 'Rotation degrees',
      opacity: 'Opacity',
      opacityAria: 'Opacity',
      opacityPercentAria: 'Opacity percent',
      visibility: 'Visibility',
      activeTween: 'Active Tween ({start} → {end})',
      easing: 'Easing',
      easingAria: 'Easing type',
      linear: 'Linear',
      easeIn: 'Ease In',
      easeOut: 'Ease Out',
      easeInOut: 'Ease In-Out',
      bounce: 'Bounce',
      elastic: 'Elastic',
      back: 'Back',
      noTween: 'No tween at current frame.',
      noTweenHint: 'Create two keyframes and add a tween between them.',
      allTweens: 'All Tweens',
      frameRange: 'Frame {start} → {end}',
      noSelection: 'Select something on the Scene or Timeline to view and edit its properties.',
      selectedObjects: '{count} objects selected',
      selectedObjectAria: 'Object to edit in selection',
      keyframe: 'Keyframe',
      frame: 'Frame:',
      activeKeyframe: '◆ Active Keyframe: Frame {frame}',
      noKeyframe: 'No keyframe at or before current frame',
      selectFrameHint: 'Select a frame from the Timeline',
      createKeyframe: 'Create Keyframe',
      updateKeyframe: 'Update Keyframe',
      stateObjects: 'Objects carrying state',
      noStateObjects: 'This keyframe has no object state.',
      copyStateToPrevious: 'Copy state to previous keyframe ({frame})',
      copyStateToNext: 'Copy state to next keyframe ({frame})',
      noPreviousKeyframe: 'No previous keyframe',
      noNextKeyframe: 'No next keyframe',
    },
    align: {
      title: 'Align',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      left: 'Align Left',
      center: 'Align Center',
      right: 'Align Right',
      top: 'Align Top',
      middle: 'Align Middle',
      bottom: 'Align Bottom',
    },
  },
  timeline: {
    prevFrame: 'Previous Frame (,)',
    pause: 'Pause (Space)',
    play: 'Play (Space)',
    playNeedsKeyframe: 'At least one keyframe is required to play',
    stop: 'Stop (.)',
    nextFrame: 'Next Frame (.)',
    addKeyframe: 'Add Keyframe (F6)',
    deselectKeyframe: 'Deselect keyframe to add at playhead',
    keyframeExists: 'Keyframe already exists at current frame',
    deleteKeyframe: 'Delete Keyframe',
    addTween: 'Add Tween (F7)',
    addTweenHint: 'Can be added between two keyframes when no tween exists',
    deleteTween: 'Delete Tween',
    frame: 'Frame:',
    time: 'Time:',
    total: 'Total:',
    totalFramesAria: 'Total frames',
    addLayer: 'Add Layer',
    newLayer: 'New layer',
    dragReorder: 'Drag to reorder',
    deleteLayer: 'Delete Layer',
    cannotDeleteTitle: 'Cannot delete layer',
    cannotDeleteLast: 'A scene must keep at least one layer. The last layer cannot be deleted.',
    cannotDeleteNonEmpty:
      'This layer is not empty. Clear its keyframes, tweens, and scene objects before deleting.',
    tweenTitle: 'Tween: {start} - {end} ({easing})',
    frameTitle: 'Frame {frame}',
    frameDeleting: 'Frame {frame} (deleting...)',
    addKeyframeAt: 'Add Keyframe (Frame {frame})',
    addTweenShort: 'Add Tween',
    clearAllKeyframes: 'Clear All Keyframes',
    clearAllTweens: 'Clear All Tweens',
  },
  stage: {
    selectionToolbar: 'Object actions',
    duplicate: 'Duplicate',
    createGroup: 'Create Group',
    createPattern: 'Create Pattern',
    ungroup: 'Ungroup',
    removeFromGroup: 'Remove from Group',
    groupName: 'Group',
    insideThisLayer: 'Inside this layer',
    bringToFront: 'Bring to Front',
    bringForward: 'Bring Forward',
    sendBackward: 'Send Backward',
    sendToBack: 'Send to Back',
    sendToLayer: 'Send to layer',
    sendInto: 'Send into',
    noSendIntoTargets: 'No objects in this layer',
    objectFallback: 'Object {id}',
    noLayers: 'No layers',
    layerFallback: 'Layer {id}',
    noLayerTitle: 'No layer selected',
    noLayerDescription: 'To add a scene object, please select a layer first.',
  },
  welcome: {
    title: 'Welcome',
    subtitle: 'You can create a new project or select a recently used project.',
    createProject: 'Create New Project',
    projectNamePlaceholder: 'Project name...',
    recentlyUsed: 'Recently Used',
    noRecent: 'No recently used projects',
    myProjects: 'My Projects',
    sampleProjects: 'Sample Projects',
    empty: 'No projects yet. Start by creating a new project!',
    movieAria: 'movie',
    previewTitle: 'Preview',
    openProject: 'Open Project',
    noDescription: 'No description',
    resolution: 'Resolution',
    fps: 'Frame rate',
    fpsValue: '{fps} fps',
    scenes: 'Scenes',
    sceneObjects: 'Scene objects',
    layers: 'Layers',
    sampleBadge: 'Sample',
  },
  aiChat: {
    deleteMessage: 'Delete message',
    thinking: 'Thinking...',
    jobs: 'Jobs',
    actions: 'Actions',
    payloads: 'Payloads',
    executionResults: 'Execution Results',
    loading: 'Loading...',
    resizePanel: 'Resize chat panel',
    selectConversation: 'Select conversation',
    newChat: 'New Chat',
    newChatTooltip: 'New chat',
    deleteConversation: 'Delete conversation',
    debugOn: 'Debug mode on',
    debugOff: 'Debug mode off',
    placeholder: 'Describe a scene ...',
    send: 'Send',
  },
  admin: {
    badge: 'Admin',
    backToEditor: 'Back to Editor',
    topbarTitle: 'Admin',
    a11y: {
      closeNav: 'Close navigation',
      openNav: 'Open navigation',
    },
    nav: {
      dashboard: 'Dashboard',
      users: 'Users',
      projects: 'Projects',
      activity: 'Activity',
      activityDesc: 'SignalR · log',
      activityTitle: 'Live SignalR connections and activity log',
      storageProviders: 'Storage Providers',
      socialProviders: 'Social Login',
      ai: 'AI',
      providers: 'Providers',
      prompts: 'Prompts',
      payment: 'Payment',
      cryptoWallets: 'Crypto Wallets',
      disclaimers: 'Disclaimers',
      install: 'Install',
      analytics: 'Analytics',
      settings: 'Settings',
      vectorPackages: 'Public Library',
    },
    vectorPackages: {
      title: 'Public Library',
      description: 'Platform library shared with every project. Import a git repository, or upload a zip. Each folder becomes its own package.',
      name: 'Package name',
      file: 'Package file',
      fileHint: 'Zip, SVG, PNG, WebP, or JPEG. A zip is unpacked into individual files.',
      upload: 'Upload package',
      uploading: 'Uploading…',
      empty: 'The public library is empty.',
      files: '{count} files',
      delete: 'Delete',
      preview: 'Files',
      hide: 'Hide',
      deleteConfirm: 'Delete "{name}" and its files?',
      uploadFailed: 'Upload failed.',
      deleteFailed: 'Could not delete the package.',
      nameRequired: 'Package name is required.',
      fileRequired: 'Choose a package file.',
      loadFailed: 'Could not load the public library.',
      gitUrl: 'Repository URL',
      gitBranch: 'Branch',
      gitPath: 'Folder',
      gitFormat: 'Format',
      formatSvg: 'SVG',
      formatPng: 'PNG',
      gitHint: 'HTTPS only. A folder such as kits becomes one package per subfolder. SVG and PNG are not imported together. Importing the same repository again updates those packages.',
      gitImport: 'Import repository',
      gitImporting: 'Importing…',
      gitImported: 'Imported {count} packages.',
      gitFailed: 'Repository could not be imported.',
      gitUrlRequired: 'Repository URL is required.',
    },
  },
} as const;
